import React from 'react';
import PropTypes from 'prop-types';
import './tasksActionButtons.scss';
import SplitButton from '../input/SplitButton.component';
import {TASK_ACTIONS} from 'utils/constants';
import {addTasksAmount} from 'utils/valueFormatter.function';
import {useNavigate} from "react-router-dom";
import {Button, ButtonType} from "components/common/Button.component";
import {DropdownPosition} from "types/gaiaComponents/dropdownButton.types";
import { useTranslation } from 'components/translations/useTranslation';

const MyTasksButtonsBarView = ({actions, userSettings, selectedTaskKeys, tasks, action}) => {

    let hasAccountingGrid = false;
    let hasDraftComment = false;

    const { translate } = useTranslation();
    /**
     * count the count/amount price of approve label
     * @param tasks
     * @return {{count: number, label: string}}
     */
    function computeApproveMessage(tasks) {

        let selectedTasks = [];
        tasks.forEach(task => {
            if (task.selected) {
                selectedTasks.push(task.task);
            }
            if (task.task.hasAccountingGrid) {
                hasAccountingGrid = true;
            }
            if (task.task.draftComment) {
                hasDraftComment = true;
            }
        });

        let finalLabel = "";
        if (selectedTasks.length > 1) {
            finalLabel = " (" + selectedTasks.length + ")";
            let cost = addTasksAmount(selectedTasks);
            if (cost) {
                finalLabel = finalLabel + ": " + cost;
            }
        }
        if (userSettings?.showCommentOnApprove || selectedTaskKeys.length > 1)
            finalLabel += " ...";

        return {
            count: selectedTasks.length,
            label: finalLabel
        };
    }

    const approveAllowed = actions.isEnabled(TASK_ACTIONS.APPROVE);
    const displayMessage = computeApproveMessage(tasks);

    const navigate = useNavigate();

    let actionList = actions.getSplitButtons().map((actionItem) => {

            let itemLabel = translate("myTasks.actionBar." + actionItem.type);
            // for 'open' action and at least 2 tasks selected change the label
            if (displayMessage.count > 1 && actionItem.type === TASK_ACTIONS.OPEN) {
                itemLabel = translate('myTasks.actionBar.' + TASK_ACTIONS.OPEN)
            }

            // split button item
            const res = {
                type: actionItem.type,
                active: actionItem.active,
                shortKey: actionItem.shortKey,
                onClick: () => {
                    action(actionItem.type, selectedTaskKeys, {...actionItem.options, navigate});
                },
                label: itemLabel
            };
            return res;
        }
    );

    const tasksWithQuickApprove = tasks.filter((task) => {
        return task.task.taskActions.includes("quick-approve") || task.task.taskActions.includes("review")
    });
    const showApproveSelected = tasks.length === tasksWithQuickApprove.length;

    return (
        <footer
            className="fixed-bottom text-center task-action-buttons px-16">
            <div className="d-flex justify-content-end my-8 gap-8 px-3 mx-1">
                {showApproveSelected &&
                    <Button
                        type={ButtonType.PRIMARY}
                        disabled={!approveAllowed}
                        onClick={() => {
                            action(TASK_ACTIONS.APPROVE, selectedTaskKeys);
                        }}
                        dataCy="myTasks.actionBar.approveSelected"
                        text={translate("myTasks.actionBar.approveSelected") + " " + displayMessage.label}
                    />
                }

                <SplitButton
                    initialLabel={translate('myTasks.actionBar.open')}
                    type={ButtonType.SECONDARY}
                    actions={actionList}
                    position={DropdownPosition.TOP_RIGHT}
                />
            </div>
        </footer>
    )
};

MyTasksButtonsBarView.propTypes = {
    actions: PropTypes.shape({
        isEnabled: PropTypes.func.isRequired,
        getSplitButtons: PropTypes.func.isRequired,
    }).isRequired,
    userSettings: PropTypes.shape({
        showCommentOnApprove: PropTypes.bool,
    }),
    selectedTaskKeys: PropTypes.array.isRequired,
    tasks: PropTypes.array.isRequired,
    action: PropTypes.func.isRequired,
};

export default MyTasksButtonsBarView;
